import { render, staticRenderFns } from "./AppTextarea.vue?vue&type=template&id=6a2186e4&scoped=true&"
import script from "./AppTextarea.vue?vue&type=script&lang=ts&"
export * from "./AppTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./AppTextarea.vue?vue&type=style&index=0&id=6a2186e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2186e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
